import { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";

const StockContext = createContext();

export const StockProvider = ({ children }) => {
    const [stockItems, setStockItems] = useState([]);
    const [stockLoading, setStockLoading] = useState(false);
    const [stockError, setStockError] = useState(null);

    const baseUrl = process.env.REACT_APP_BASE_URL;

    const fetchStockData = useCallback(async (token, outletName) => {
        if (!outletName || !token) return;

        setStockLoading(true);
        setStockError(null);
        try {
            setStockItems([]);

            const res = await axios.post(`${baseUrl}/getstockstatement`, {
                token,
                outlet_name: outletName
            });

            setStockItems(res.data.stock_items || []);
            setStockError(null);
        } catch (err) {
            console.log(err);
            setStockError(
                err?.response?.data?.error ||
                err?.response?.data?.message ||
                "Failed to fetch stock items"
            );
        } finally {
            setStockLoading(false);
        }
    }, [baseUrl]);

    return (
        <StockContext.Provider
            value={{
                stockItems,
                stockLoading,
                stockError,
                fetchStockData
            }}
        >
            {children}
        </StockContext.Provider>
    );
};

export const useStock = () => useContext(StockContext);